export type PageType = "main" | "internal" | "modal";

export const isInternalPage = (pathname: string) => {
  //TODO: refactor this to use a constant for the language prefix
  return pathname.startsWith("/pages") || pathname.startsWith("/de/pages");
};

export const isFormPage = (pathname: string) => {
  return pathname.startsWith("/forms") || pathname.startsWith("/de/forms");
};

export const isNewsPage = (pathname: string) => {
  return pathname.startsWith("/news") || pathname.startsWith("/de/news");
};

export const isPrivacyPolicy = (pathname: string) => {
  return (
    pathname.startsWith("/privacy-policy") ||
    pathname.startsWith("/de/privacy-policy")
  );
};

export const isLegalNotice = (pathname: string) => {
  return pathname.includes("legal-notice");
};

export const isModalPage = (pathname: string) => {
  // Modal like pages: privacy policy, contact forms, etc, legal-notice.
  return (
    isPrivacyPolicy(pathname) ||
    isFormPage(pathname) ||
    isNewsPage(pathname) ||
    isLegalNotice(pathname)
  );
};

export const getPageType = (pathname: string): PageType => {
  if (isInternalPage(pathname)) {
    return "internal";
  }

  if (isModalPage(pathname)) {
    return "modal";
  }

  return "main";
};
